import { render, staticRenderFns } from "./FoodCatalogManage.vue?vue&type=template&id=7e1d4b3f&scoped=true"
import script from "./FoodCatalogManage.vue?vue&type=script&lang=js"
export * from "./FoodCatalogManage.vue?vue&type=script&lang=js"
import style0 from "./FoodCatalogManage.vue?vue&type=style&index=0&id=7e1d4b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1d4b3f",
  null
  
)

export default component.exports